/**
 * DTGD-1551: identifica para o backend em qual portal (white-label) o login
 * acontece. E o mesmo valor usado para buscar o layout do grupo, entao casa com
 * `companies_groups.portal_url`.
 *
 * Em dev local (`yarn start`) o host é "localhost:3000", que não casa com
 * nenhum grupo: REACT_APP_TENANT_HOST (ex.: no .env.development.local) faz o
 * login se passar por um portal real. Só vale em development — o build de
 * produção ignora a variável.
 */
export const tenantHost = () =>
  (process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_TENANT_HOST) ||
  window.location.host;

/**
 * DTGD-1561: o token do login v2 carrega o grupo (`id_group`). Sessoes abertas
 * antes do deploy tem token v1 e continuam nas rotas v1 ate novo login.
 */
export const tokenHasGroup = token => {
  try {
    const payload = JSON.parse(
      atob(String(token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/')),
    );
    return Boolean(payload && payload.id_group);
  } catch {
    return false;
  }
};
